import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Works for both the app scroll container and plain window scroll (public pages)
    const container = document.getElementById('app-main-scroll');
    const onScroll = () => {
      const scrolled = container ? container.scrollTop : window.scrollY;
      setVisible(scrolled > 300);
    };
    const target = container ?? window;
    target.addEventListener('scroll', onScroll, { passive: true });
    return () => target.removeEventListener('scroll', onScroll);
  }, []);

  const scrollUp = () => {
    const container = document.getElementById('app-main-scroll');
    if (container) container.scrollTo({ top: 0, behavior: 'smooth' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollUp}
      aria-label="Back to top"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(12px) scale(0.85)',
        pointerEvents: visible ? 'auto' : 'none',
        transition: 'opacity 0.2s ease, transform 0.2s ease',
      }}
      className="fixed bottom-20 md:bottom-8 right-4 md:right-6 z-50 w-10 h-10 rounded-full bg-stone-900 dark:bg-stone-700 text-white shadow-xl hover:bg-orange-500 dark:hover:bg-orange-500 flex items-center justify-center"
    >
      <ChevronUp size={18} />
    </button>
  );
}
